const state = {
  user: {},
};

const getters = {
  get: state => state.user,
};

const mutations = {
  SET(state, data) {
    state.user = _.isPlainObject(data) ? data : {};
  },
};

const actions = {
  set({ commit }, data) {
    commit('SET', data)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
